<template>
  <!-- 企业服务-客户管理 -->
  <div class="firm-body">
    <div class="title-Individual-center">
      <span class="firm-clickable" @click="handelBack">企业中心</span
      ><i class="el-icon-arrow-right"></i
      ><span class="firm-clickable" @click="handelBack">代理服务</span
      ><i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">客户管理</span>
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <div class="main-body-box">
        <!-- 筛选 -->
        <el-form
          :model="screenData"
          :inline="true"
          class="screen"
          @submit.native.prevent="handelSearch"
        >
      <el-form-item label="企业名称：">
      <div class="size-search">
      <el-input maxlength="30"
      v-model="screenData.name"
      placeholder="请输入企业名称"
      ></el-input>
      </div>
      </el-form-item>
      <el-form-item label="联系电话：" class="user-Id">
      <div class="size-search">
      <el-input maxlength="30"
      v-model="screenData.phone"
      placeholder="请输入联系电话"
      ></el-input>
      </div>
      </el-form-item>
      <el-form-item label="纳税类别：" class="user-Id">
      <div class="size-search">
      <el-select v-model="screenData.Type" placeholder="请选择纳税类别">
      <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      <el-form-item label="统一社会信用代码：">
      <div class="size-search">
      <el-input maxlength="30"
      v-model="screenData.code"
      placeholder="请输入统一社会信用代码"
      ></el-input>
      </div>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="代理时间：" class="user-Id">
      <el-date-picker
      v-model="screenData.value"
      type="monthrange"
      range-separator="-"
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      value-format="yyyy-MM"
      clearable
      @clear="screenData.value = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
        <!--  -->
        <div class="table-top-Controls">
          <div class="RemainingLocation">
            <el-button type="primary" class="action-btn firm-clickable" @click="handelUp">添加多家</el-button>
            <el-button type="primary" class="action-btn firm-clickable" @click="handelAddAndEditor(0)">添加一家</el-button>
            <el-button type="primary" class="action-btn firm-clickable" @click="handelDelete(0)">删除</el-button>
          </div>
        </div>
        <!-- 列表 -->
        <div class="Table">
          <Table
            :tableData="tableData"
            :ClearSel="ClearSel"
            :pagingObj="pagingObj"
            @handelPurchase="handelPurchase"
            @handelRefund="handelRefund"
            @handelDetails="handelDetails"
            @handelDelete="handelDelete"
            @handelAddAndEditor="handelAddAndEditor"
            @handelHesitation="handelHesitation"
            @handelEvaluation="handelEvaluation"
            @handleSelectionChange="handleSelectionChange"
          ></Table>
        </div>
        <!-- 底部分页 -->
        <div class="paging-box">
          <div class="paging">
            <paging
              :pagingObj="pagingObj"
              @handleCurrentChange="handleCurrentChange"
            ></paging>
          </div>
        </div>
      </div>
    </div>
    <!-- 购买/续费 -->
    <Purchase
      :VisiblePurchase="VisiblePurchase"
      :Purchase="Purchase"
      :self="self"
      :PurchaserInfo="PurchaserInfo"
      :ToWhom="ToWhom"
      @handleClose="VisiblePurchase = false"
      @handleUnderstand="handleUnderstand"
      @handleSuccess="handleSuccess"
    ></Purchase>
    <!-- 立即退款/申请退款 -->
    <Refund
      :VisibleRefund="VisibleRefund"
      :Refund="Refund"
      :ProxyBookkeeping="row"
      :distinguish='2'
      @handleCloseVisibleRefund="VisibleRefund = false"
      @handleUnVisibleRefund="handleUnVisibleRefund"
    ></Refund>
    <!-- 详情 -->
    <Details
      :rowDetails="rowDetails"
      :VisibleDetails="VisibleDetails"
      @handleCloseDetails="VisibleDetails = false"
      @handleDetails="handleDetails"
    ></Details>
    <!-- 上传 -->
    <UpProxy
      :VisibleUp="VisibleUp"
      @handleCloseUp="VisibleUp = false"
      @handleConfirmUp="handleConfirmUp"
    ></UpProxy>
    <!-- 添加/编辑 -->
    <AddInformation
      :AddEditor="AddEditor"
      :row="row"
      :dialogAdd="dialogAdd"
      @handleShutDown="dialogAdd = false"
      @handleVerify="handleVerify"
    ></AddInformation>
    <!-- 立即办理 -->
    <Hesitation
      :VisibleHesitation="VisibleHesitation"
      @handleCloseHesitation="VisibleHesitation = false"
      @handleUnHesitation="handleUnHesitation"
    ></Hesitation>
    <!-- 服务评价弹窗 -->
    <EvaluationDialog
      :VisibleEvaluation="VisibleEvaluation"
      :orderNumber="evaluationRow.orderNumber"
      :proxyId="evaluationRow.proxyId"
      :evaluationMonth="evaluationRow.evaluationMonth"
      :handleTypeName="'代理记账'"
      :evaluatedName="evaluationRow.evaluatedName || evaluationRow.beEvaluatedName || evaluationRow.handlerName || evaluationRow.staffName || ''"
      @handleCloseEvaluation="handleCloseEvaluation"
      @handleSuccess="handleEvaluationSuccess"
    ></EvaluationDialog>
  </div>
</template>

<script>
// 引入接口

import * as API from "@/assets/api/Agency/Enterprise.js";
import Purchase from "../Bookkeeping/components/IndexCom/Purchase.vue";
import Refund from "../Bookkeeping/components/IndexCom/NewDetails.vue";
import Table from "./components/Table.vue";
import Details from "./components/Details.vue";
import UpProxy from "./components/UpProxy.vue";
import AddInformation from "./components/AddInformation.vue";
import Hesitation from "../Bookkeeping/components/IndexCom/Hesitation.vue";
import EvaluationDialog from "../../components/EvaluationDialog.vue"; // 服务评价弹框
// 引入分页组件
import paging from "../../../../../../components/paging.vue";
export default {
  data() {
    return {
      screenData: {
        value: null, // 时间
        name: "", //企业名称
        phone: "", //电话
        Type: "", //纳税类别
        code: "", // 统一
      },
      options: [
        {
          label: "小规模纳税人",
          value: 0,
        },
        {
          label: "一般纳税人",
          value: 1,
        },
      ], //变更类型选择
      tableData: [],
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      Purchase: 0, //0购买1续费2升级
      VisiblePurchase: false, //购买/续费
      Refund: 1, // 0立即退款1申请退款
      VisibleRefund: false, //立即退款/申请退款
      VisibleDetails: false, //详情
      VisibleUp: false, //上传
      dialogAdd: false, //添加/编辑
      AddEditor: "", //0添加1编辑
      DeleNum: "", //0批量删除1单个删除
      row: {}, //编辑回显数据

      arrId: [], //表格多选
      ClearSel: 0,
      rowDetails: {}, //详情
      self: {}, //企业信息
      ToWhom: 1, //0给自己够买1给代理的公司购买
      PurchaserInfo: {}, //购买方信息
      VisibleHesitation: false, // 立即办理弹窗
      VisibleEvaluation: false, // 服务评价弹窗
      evaluationRow: {}, // 评价行数据
    };
  },
  watch: {},
  components: {
    paging,
    Table,
    Purchase, //购买 续费 升级弹窗
    Refund, //立即退款/申请退款
    Details, //详情
    UpProxy, //上传
    AddInformation, //添加/编辑
    Hesitation,
    EvaluationDialog, // 服务评价弹框
  },
  created() {
    this.companyCustomers();
    this.companySelectCustomers();
  },
  mounted() {
    this.$bus.$on("refresh-company-customers", this.companyCustomers);
  },
  destroyed() {
    this.$bus.$off("refresh-company-customers", this.companyCustomers);
  },
  methods: {
    //付款成功
    handleSuccess() {
      this.VisiblePurchase = false;
    },
    //查询客户列表(客户下拉选择)
    companySelectCustomers() {
      if (!this.$checkActionIpu()) return
      API.companySelectCustomers().then((res) => {
        this.PurchaserInfo = res.data.self;
      });
    },
    // 表格多选
    handleSelectionChange(val) {
      console.log(val);
      this.arrId = val;
    },
    // 搜索
    handelSearch() {
      this.pagingObj.currentPage = 1;
      this.companyCustomers();
    },
    // 重置
    handelReset() {
      this.pagingObj.currentPage = 1;
      this.screenData = {
        value: null, // 时间
        name: "", //企业名称
        phone: "", //电话
        Type: "", //纳税类别
        code: "", // 统一
      };
      this.companyCustomers();
    },

    // 查询客户分页列表
    companyCustomers() {
      var time;
      var time1;
      var range = this.screenData.value;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0];
        time1 = range[1];
      }
      var data = {
        data: {
          companyName: this.screenData.name, //客户企业
          phone: this.screenData.phone, //电话
          creditCode: this.screenData.code, //信用代码
          taxType: this.screenData.Type, //纳税人类型
          startTime: time, //代理开始时间 月
          endTime: time1, //代理结束时间 月
        },
      };
      API.companyCustomers(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.pagingObj.totalDevice = res.data.total;
        }
      });
    },
    // 添加/编辑确定
    handleVerify() {
      this.companyCustomers();
      this.dialogAdd = false;
    },
    // 点击添加/编辑
    handelAddAndEditor(num, row) {
      if (!this.$checkAction()) return
      if (num == 1) {
        this.row = row;
        this.AddEditor = num;
        this.dialogAdd = true;
      } else {
        this.row = {};
        this.AddEditor = num;
        this.dialogAdd = true;
      }
    },
    // 上传确定
    handleConfirmUp() {
      this.companyCustomers();
      this.VisibleUp = false;
    },
    // 上传
    handelUp() {
      if (!this.$checkAction()) return
      this.VisibleUp = true;
    },
    // 删除确认
    handleVDelete() {
      if (this.DeleNum == 0) {
        //批量删除
        var arr = [];
        for (var i in this.arrId) {
          arr.push(this.arrId[i].id);
        }
        var data = {
          data: {
            ids: arr,
          },
        };
        API.delCompanyCustomers(data).then((res) => {
          if (res.code == 0 && res.data == true) {
            this.companyCustomers();
            this.$tool.PromptBox("success", "操作成功");
            this.arrId = [];
          } else if (res.code == 0 && res.data == false) {
            this.$tool.PromptBox("warning", "代理记账中的企业无法删除！");
            this.arrId = [];
          }
        });
      } else {
        var arr = [];
        arr[0] = this.row.id;
        var data = {
          data: {
            ids: arr,
          },
        };
        API.delCompanyCustomers(data).then((res) => {
          if (res.code == 0) {
            this.companyCustomers();
            this.$tool.PromptBox("success", "操作成功");
            this.row = {};
          }
        });
      }
      this.ClearSel++;
    },
    // 删除
    handelDelete(num, row) {
      if (!this.$checkAction()) return
      this.DeleNum = num;
      if (this.arrId.length < 1 && num == 0) {
        // 请选选择
        this.$tool.PromptBox("warning", "请先选择要删除的数据");
      } else if (num == 1) {
        this.row = row;
        this.$confirmWithScroll("是否删除该数据？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleVDelete();
          })
          .catch(() => {});
      } else {
        this.$confirmWithScroll("是否删除已选中数据？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleVDelete();
          })
          .catch(() => {});
      }
    },
    //   // 立即退款/申请退款确认
    handleUnVisibleRefund(textarea) {
      // console.log(this.row);
      var data = {
        data: {
          creditCode: this.row.creditCode,
          refundReason: textarea,
        },
      };
      API.customerRequestRefund(data).then((res) => {
        if (res.code == 0) {
          this.$tool.PromptBox("success", "操作成功");
          this.companyCustomers();
        }
      });

      this.VisibleRefund = false;
    },
    // 申请退款立即退款
    handelRefund(val, row) {
      this.row = row;
      this.Refund = val;
      this.VisibleRefund = true;
    },
    // 立即办理
    handelHesitation(row) {
      if (!this.$checkAction()) return;
      this.row = row;
      if (!row.orderNumber) {
        this.$tool.PromptBox("warning", "缺少订单号");
        return;
      }
      this.VisibleHesitation = true;
    },
    // 立即办理确认
    handleUnHesitation() {
      this.$tool
        .InvoiceProcess(
          "/global/proxy/bookkeepingProcess",
          this.row.orderNumber
        )
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.companyCustomers();
          }
        });
      this.VisibleHesitation = false;
    },
    // 服务评价
    handelEvaluation(row) {
      if (!this.$checkAction()) return;
      if (!row.proxyId) {
        this.$tool.PromptBox("warning", "缺少代理ID");
        return;
      }
      this.evaluationRow = row;
      this.VisibleEvaluation = true;
    },
    // 关闭服务评价弹框
    handleCloseEvaluation() {
      this.VisibleEvaluation = false;
    },
    // 服务评价成功
    handleEvaluationSuccess() {
      this.companyCustomers();
    },
    // 购买 / 续费 /升级
    handelPurchase(val, row) {
      this.self = row;
      this.Purchase = val;
      this.VisiblePurchase = true;
    },
    // 购买/续费确认
    handleUnderstand() {
      this.VisiblePurchase = false;
    },
    // 详情弹窗确认
    handleDetails() {
      this.VisibleDetails = false;
    },
    // 列表点击详情
    handelDetails(row) {
      this.rowDetails = row;
      this.VisibleDetails = true;
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.companyCustomers();
    },
    // 返回
    handelBack() {
      this.$router.push({
        path: "/Choice",
      });
    },
  },
};
</script>

<style scoped lang="less">
.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  .firm-Content-subject {
    width: 100%;
    min-height: 720px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    padding: 30px;
    // 主体内容
    .main-body-box {
      width: 100%;
      min-height: 100px;
      // 筛选
      .screen {
        margin-top: 10px;
        margin-bottom: 0;
        position: relative;
      }
      // 表上方的操作项
      .table-top-Controls {
        width: 100%;
        height: 35px;
        line-height: 35px;
        display: flex;
        margin-top: 20px;
        .action-btn {
          width: 100px;
          height: 35px;
          background: #409eff !important;
          border-color: #409eff !important;
          border-radius: 5px;
          font-size: 14px;
          color: #ffffff !important;
          text-align: center;
          border: none;
          padding: 0 !important;
          line-height: 1 !important;
          display: inline-flex !important;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .RemainingLocation {
          display: flex;
          flex: 1;
          justify-content: flex-end;
          .action-btn {
            margin-left: 20px;
          }
        }
      }
      //   表格
      .Table {
        min-height: 450px;
        margin-top: 30px;
        // border: 1px solid gold;
      }
      // 分页
      .paging-box {
        width: 100%;
        height: 22px;
        margin-top: 30px;
        display: flex;
        justify-content: flex-end;
        .paging {
          width: 90%;
          height: 100%;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
}
</style>
